const flatMap = require('lodash/flatMap');
const join = require('./join');
const split = require('./split');

/**
 * Join multiple partial paths into a single path string.
 * @param {...Path} paths Paths to combine
 * @returns {Path<string>} Resolved path
 * @example
 * joinPartialPaths('fx.pairs[0]', 'bid.price');
 * // => 'fx.pairs[0].bid.price'
 * @example
 * joinPartialPaths('data', 'usersById["first.last@db.com"]');
 * // => 'data.usersById["first.last@db.com"]'
 */
function joinPartialPaths(...paths) {
  return join(flatMap(paths, (path) => split(path)));
}

module.exports = joinPartialPaths;
